import React from "react";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import cn from "classnames";
import styles from "./styles.module.sass";
import FormControl from "react-bootstrap/FormControl";

const TextInput = ({
  values,
  handleChange,
  touched,
  errors,
  label,
  placeholder,
  type = "text",
  formName,
  isTextarea = false,
  disabled,
  className,
  idName,
}) => {
  let additionalProps = {};
  if (isTextarea) {
    additionalProps.as = "textarea";
  }
  const isValid = touched[formName] && !errors[formName];
  // if (type != 'firstName' && type != 'lastName' && type != 'password' && values[formName] == undefined && values[formName] != 'propertyId') {
  //   values[formName] = ''
  // }
  return (
    <Form.Group
      className={styles.textInputContainer}
      as={Col}
      xs="12"
      controlId={idName ? idName : "name"}
    >
      <Form.Label>{label}</Form.Label>
      <FormControl
        onWheel={(e) => e.target.blur()}
        className={cn(
          {
            [styles.error]: touched[formName] && errors[formName],
          },
          className
        )}
        placeholder={placeholder}
        type={type}
        name={formName}
        disabled={disabled}
        value={values[formName] ?? ""}
        onChange={handleChange}
        isValid={isValid}
        {...additionalProps}
      />
      {touched[formName] && errors[formName] && (
        <>
          <div className="text-danger">{errors[formName]}</div>
        </>
      )}
    </Form.Group>
  );
};
export default TextInput;
